import { Switch } from "@mui/material";
import React, { useEffect, useState } from "react";
import { UpdateCuration } from "../../apis/Curation";

function ShowPopupSwitch({ value, curation }) {
  const [showInPopup, setshowInPopup] = useState(curation.show_in_popup);

  const handleClick = async () => {
    curation = { ...curation, show_in_popup: !showInPopup };

    await UpdateCuration(
      { title: curation.title, show_in_popup: !showInPopup },
      curation.id
    );

    setshowInPopup(!showInPopup);
  };

  useEffect(() => {
    setshowInPopup(curation.show_in_popup);
  }, [curation]);

  return (
    <Switch
      checked={showInPopup}
      onChange={handleClick}
      inputProps={{
        "aria-label": "controlled",
      }}
    />
  );
}

export default ShowPopupSwitch;